<template>
  <div class="w-100vw">
    <HeaderCon></HeaderCon>
    <div class="app" id="app">
      <router-view></router-view>
      <Footer></Footer>
    </div>
    <ScrollProgressCircle />
  </div>
</template>
<script>
import HeaderCon from './components/header.vue'
import Footer from './components/footer.vue'
export default {
  components: {
    HeaderCon,
    Footer
  },
  mounted() {
  },
  data() {
    return {
    }
  },
  methods: {
  },
}

</script>

<style lang="less">
.card-item {
  cursor: pointer;
  transition: transform 0.25s ease;
  transform-origin: center center;
}

.card-scale-active {
  transform: scale(1.1);
}

#app {
  width: 100vw;
  font-size: 16px;
}

.w-100vw {
  padding-top: 70px;
}

@media screen and (max-width: 768px) {

  .w-100vw {
    padding-top: 60px;
  }
}

@media screen and (max-width: 480px) {
  .w-100vw {
    padding-top: 50px;
  }

}

.w-100vw,
html,
body {
  width: 100vw;
  overflow-x: hidden;
  // 去掉横滚动轴
}

@media screen and (min-width: 1650px) and (max-width: 1919px) {
  .app {
    transform: scale(1.1);
    transform-origin: center top;
  }
}

/* 1920px ~ 2299px */
@media screen and (min-width: 1920px) and (max-width: 2299px) {
  .app {
    transform: scale(1.2);
    transform-origin: center top;
  }
}

/* ≥2300px 超大屏 */
@media screen and (min-width: 2300) and (max-width: 3000) {
  .app {
    transform: scale(1.3);
    transform-origin: center top;
  }
}


/* ≥2300px 超大屏 */
@media screen and (min-width: 3001) and (max-width: 3999) {
  .app {
    transform: scale(1.4);
    transform-origin: center top;
  }
}

// 大于3000
@media screen and (min-width: 3000px) {
  .app {
    transform: scale(1.5);
    transform-origin: center top;
  }
}


* {
  margin: 0;
  padding: 0;
  list-style: none;
  user-select: none;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  transition: all .3s;
}

.small-title {
  color: #100f0d;
  font-size: 26px;
  margin-bottom: 40px;
  margin-top: 50px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 4px;
    background: #0078d0;
    bottom: -10px;
    left: 0;
  }
}

.big-title {
  text-align: center;
  transition: all .3s;
  max-width: 1200px;
  margin: 0 auto 40px;
  position: relative;
  font-size: 36px;
  font-weight: bold;
  // 首字母大写
  // text-transform: capitalize;
}

.w-1200 {
  max-width: 1400px;
  // max-width: 1200px;
  zoom: 0.85;
  margin: 0 auto;
}


.read-more-btn {
  background: #DBAE00;
  width: 220px;
  font-size: 20px;
  color: #fff;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 60px;
  margin: 70px auto 10px;
  transition: all .3s;
  cursor: pointer;

  i {
    margin-left: 5px;
  }
}

.banner {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  height: 800px;
  overflow: hidden;

  &::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0));
    z-index: 2;
  }


  .bg-pic,
  img {
    height: auto;
    width: 100%;
  }

  .bg-pic {
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .text-bg {
    width: 60%;
    height: auto;
    display: block;
  }

  .font {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    height: 100%;

    .w-1200 {
      box-sizing: border-box;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .banner-title1 {
    color: #FFEEC8;
    font-size: 24px;
    width: 100%;
    text-align: left;
    margin-bottom: 48px;
  }

  .banner-title2,
  .banner-title3 {
    color: #FFF;
    // font-family: "Olympic Sans Bold";
    font-size: 110px;
    font-weight: 700;
    text-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);
  }

  .banner-title3 {
    font-style: italic;
  }

  .banner-title4 {
    color: #FFEEC8;
    margin-top: 96px;
    // font-family: "Olympic Sans Medium";
    font-size: 32px;
    font-weight: 500;
    position: relative;
    // width: 60%;
    text-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);

    &::before {
      content: '';
      display: inline-block;
      width: 240px;
      height: 2px;
      background: #fff;
      position: absolute;
      top: -48px;
      left: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .w-1200 {
    zoom: 1;
    width: 100%;
    box-sizing: border-box;
  }

  .banner {
    height: 450px;
    min-height: 300px;

    .w-1200 {
      padding: 15px;
      box-sizing: border-box;
    }

    .bg-pic {
      height: 100%;
      object-fit: cover;
    }

    .text-bg {
      width: 95%;
    }


    .banner-title1 {
      color: #FFEEC8;
      font-size: 14px;
      width: 100%;
      text-align: left;
      margin-bottom: 14px;
    }

    .banner-title2,
    .banner-title3 {
      color: #FFF;
      // font-family: "Olympic Sans Bold";
      font-size: 34px;
      line-height: 1.2;
      font-weight: 700;
      text-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);
    }

    .banner-title3 {
      font-style: italic;
    }

    .banner-title4 {
      color: #FFEEC8;
      margin-top: 32px;
      // font-family: "Olympic Sans Medium";
      font-size: 15px;
      font-weight: 500;
      position: relative;
      width: 100%;

      &::before {
        content: '';
        display: inline-block;
        width: 120px;
        height: 2px;
        background: #fff;
        position: absolute;
        top: -16px;
        left: 0;
      }
    }
  }

  .big-title {
    font-size: 28px;
    margin-bottom: 20px;
  }

  .read-more-btn {
    width: 160px;
    height: 45px;
    box-sizing: border-box;
    padding: 0 0;
    font-size: 14px;
    margin: 30px auto 1px;
  }

  .small-title {
    color: #100f0d;
    font-size: 20px;
    margin-bottom: 20px;
    margin-top: 30px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 30px;
      height: 2px;
      background: #0078d0;
      bottom: -10px;
      left: 0;
    }
  }

}


@media screen and (max-width: 480px) {

  .banner {
    height: 290px;
    overflow: hidden;
    min-height: 100px;

    .bg-pic {
      height: 100%;
      object-fit: cover;
    }

    .text-bg {
      width: 90%;
    }
  }

  .big-title {
    font-size: 22px;
  }
}


.cup {
  cursor: pointer;
}

.u-line-1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.u-line-2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.u-line-3 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
<style>
.animate-fade-out {
  animation: fadeOut .5s ease-in-out;
}

@keyframes fadeOut {
  from {
    opacity: 0;
    transform: translateY(100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-out-2 {
  animation: fadeOut .5s 0.2s ease-in-out;
}

.animate-fade-out-4 {
  animation: fadeOut .5s 0.4s ease-in-out;
}

.animate-fade-out-6 {
  animation: fadeOut .5s 0.6s ease-in-out;
}


.animate-fade-in {
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.animate-slide-in-left {
  animation: slideInLeft 0.8s 1s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in-right {
  animation: slideInRight 0.8s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(60px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-scale {
  animation: slideScale 0.8s ease-out;
}

@keyframes slideScale {
  from {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1.4);
  }

  to {
    transform: scale(1);
  }
}

.animate-scale-small-big {
  animation: slideScale 0.8s ease-out;
}

@keyframes slideScale {
  from {
    transform: scale(0.8);
  }

  to {
    transform: scale(1);
  }
}

.rotate {
  animation: rotateAnimation 1s linear;
}

@keyframes rotateAnimation {
  from {
    transform: scale(.6) rotate(240deg);
  }

  to {
    transform: scale(1) rotate(360deg);
  }
}




/* 整体滚动条宽度 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 20px;
}

/* 滑块 */
::-webkit-scrollbar-thumb {
  background: #0078d0;
  /* 紫色系贴合你的主题 */
  width: 8px;
  height: 8px;
  border-radius: 100px;
  /* 用「内边距+背景色」做出圆形效果 */
  min-height: 8px;
  /* 防止内容太少时被压缩 */
  max-height: 8px;
  /* 防止内容太多时被拉长 */
}
</style>


// WEBPACK FOOTER //
// src/App.vue